// 自定义列信息
export const customColumns = [
  {
    key: 'base_info',
    children: [
      {
        key: 'department',
      },
      {
        key: 'direct_sale',
      },
      {
        key: 'product',
      },
      {
        key: 'app_marketing_type',
      },
    ],
  },

  {
    key: 'impression_click_cost',
    children: [
      {
        key: 'served_request',
        isSelected: true,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'cost_cash',
        isSelected: true,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'impression_total',
        isSelected: true,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'click_total',
        isSelected: true,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'cost_total',
        isSelected: true,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'cost_coupon',
        isSelected: true,
        isHover: true,
        sortable: true,
        filterable: false,
      },
    ],
  },

  {
    key: 'good_effect',
    children: [
      {
        key: 'cr',
        isSelected: false,
        sortable: true,
        filterable: false,
      },
      {
        key: 'cc',
        isSelected: false,
        sortable: true,
        filterable: false,
      },
      {
        key: 'cpm',
        isSelected: false,
        sortable: true,
        filterable: false,
      },
      {
        key: 'list_ctr',
        isSelected: false,
        sortable: true,
        filterable: false,
      },
      {
        key: 'detail_ctr',
        isSelected: false,
        sortable: true,
        filterable: false,
      },
      {
        key: 'list_acp',
        isSelected: false,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'detail_acp',
        isSelected: false,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'list_ecpm',
        isSelected: false,
        sortable: true,
        filterable: false,
      },
      {
        key: 'detail_ecpm',
        isSelected: false,
        sortable: true,
        filterable: false,
      },
    ],
  },

  {
    key: 'agent_adv',
    children: [
      {
        key: 'agent',
        isSelected: false,
      },
      {
        key: 'account',
        isSelected: false,
      },
      {
        key: 'category',
        isSelected: false,
      },
    ],
  },

  {
    key: 'plans_and_ideas',
    children: [
      {
        key: 'put_plans_num',
        isSelected: false,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'put_ideas_num',
        isSelected: false,
        isHover: true,
        sortable: true,
        filterable: false,
      },
      {
        key: 'new_ideas_num',
        isSelected: false,
        isHover: true,
        sortable: false,
        filterable: false,
      },
      {
        key: 'idea_type',
        isSelected: false,
        sortable: false,
        filterable: false,
      },
      {
        key: 'unit',
        isSelected: false,
        sortable: false,
        filterable: false,
      },
      {
        key: 'is_ocpc',
        isSelected: false,
        sortable: false,
        filterable: false,
      },
    ],
  },

  {
    key: 'media_and_adslot',
    children: [
      {
        key: 'media_type',
        sortable: false,
        filterable: false,
      },
      {
        key: 'adslot_type',
        sortable: false,
        filterable: false,
      },
    ],
  },
];

// 固定显示的表格列
export const fixedColumns = [
  {
    key: 'base_info',
    children: [
      {
        key: 'date',
      },
    ],
  },
];

// 折线图指标
export const fields = [
  'cost_cash',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_coupon',
];

// 饼图维度
export const dimensions = [
  'department',
  'media_type',
  'adslot_type',
  'category',
];
